import { toEm, toRem } from "shared/helpers";
import styled from "styled-components";

export const HivesHeadWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${toRem(12)};
    padding: ${toRem(16)} 0;
`;

type RowProps = { $overflow?: string };
export const HivesHeadRow = styled.div<RowProps>`
    display: flex;
    gap: ${toRem(12)};
    overflow: ${(p) => p.$overflow || "initial"};
    scrollbar-width: none;

    .popover__root {
        width: max-content;
        max-width: 100%;
    }

    .tagitem__label {
        &:has(svg) {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    @media (width < ${toRem(768)}) {
        gap: ${toRem(8)};
    }
`;

export const InputContainer = styled.div`
    width: ${toRem(220)};
    
    @media screen and (max-width: 768px) {  
        width: 100%;
    }
`;

export const DateWrapper = styled.div`
    --max-width: ${toRem(220)};
    max-width: var(--max-width);
    flex: 0 1 var(--max-width);

    .input {
        min-width: 0;
    }

    @media (width < ${toEm(1200)}) {
        --max-width: ${toRem(180)};
    }
    .dropdown {
        max-width: var(--max-width);
    }

    @media (width < ${toRem(768)}) {
        --max-width: calc(50% - ${toRem(4)});
        .popover__root {
            width: 100%;
        }
        .dropdown {
            width: 100%;
        }
    }
`;
